import { render, staticRenderFns } from "./CatalogSetting.vue?vue&type=template&id=6acf73b4&scoped=true&"
import script from "./CatalogSetting.vue?vue&type=script&lang=js&"
export * from "./CatalogSetting.vue?vue&type=script&lang=js&"
import style0 from "./CatalogSetting.vue?vue&type=style&index=0&id=6acf73b4&scoped=true&lang=scss&"
import style1 from "./CatalogSetting.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6acf73b4",
  null
  
)

export default component.exports